function injectStyle (ssrContext) {
  require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-b5799bdc\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!../../../node_modules/string-replace-webpack-plugin/loader.js?id=pnre6zws23l!../../../node_modules/string-replace-webpack-plugin/loader.js?id=hfo8n7cvtpt!./SearchAutocomplete.vue")
}
var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!../../../node_modules/string-replace-webpack-plugin/loader.js?id=pnre6zws23l!../../../node_modules/string-replace-webpack-plugin/loader.js?id=hfo8n7cvtpt!./SearchAutocomplete.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-b5799bdc\",\"hasScoped\":true}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!../../../node_modules/string-replace-webpack-plugin/loader.js?id=pnre6zws23l!../../../node_modules/string-replace-webpack-plugin/loader.js?id=hfo8n7cvtpt!./SearchAutocomplete.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b5799bdc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/search/SearchAutocomplete.vue
// module id = 66
// module chunks = 0